<template>
    <div id="TicketSettings">
        <div class="tabs">
            <button
                v-for="tab in tabs"
                :key="tab.id"
                :class="{ active: selectedTab === tab.id }"
                @click="selectedTab = tab.id"
            >
                {{ tab.label }}
            </button>
        </div>
        <div class="tab-content">
            <div v-if="selectedTab === 'TicketForwarding'">
                <TicketForwarding />
            </div>
        </div>
    </div>
</template>

<script>
import TicketForwarding from "./TicketForwarding.vue";

export default {
    name: "TicketSettings",
    components: {
        TicketForwarding,
    },
    data() {
        return {
            tabs: [
                { id: "TicketForwarding", label: this.$t(`ticket.ticketForwarding`) || "Ticket Forwarding" },
            ],
            selectedTab: "",
        };
    },
    methods: {
    },
    mounted() {
        this.selectedTab = this.tabs[0].id;
    },
};
</script>

<style lang="scss" scoped>
#TicketSettings {
    font-family: Arial, sans-serif;
    color: #333;

    .tabs {
        display: flex;
        justify-content: space-between;
        border-bottom: 2px solid #f1f1f1;
        margin-bottom: 20px;

        button {
            flex: 1;
            padding: 10px 0;
            text-align: center;
            font-size: 16px;
            cursor: pointer;
            background: none;
            border: none;
            outline: none;
            transition: all 0.3s ease;

            &:hover {
                background: #f9f9f9;
            }

            &.active {
                color: #007bff;
                font-weight: bold;
                border-bottom: 2px solid #007bff;
            }
        }
    }

    .tab-content {
    }
}
</style>
